import React, { useEffect, useState } from 'react';
import {useFetchCategory } from '../../hooks/useFetchData';
import { Formik, Field, Form, ErrorMessage, FieldArray } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { useNavigate, useLocation } from 'react-router-dom';
import imageCompression from 'browser-image-compression';



const PostForm = ({ formConfig, apiUrl, title, type, setCurrentPage, currentPage, setIsLogin, hundleSearch, closeModal, setSearchParams, openModal, initialValues, setIsWrong}) => {
  const { data: categories, loading, error } = useFetchCategory(); 
  const [imageFields, setImageFields] = useState([0]);
  const maxImages = type === "postform" ? 10 : 1;
  const [thingsCat, setThingsCat] = useState('2');
  const navigate = useNavigate();
  const path = window.location.pathname;
  const [previews, setPreviews] = useState({});
  const [pushSubmit, setPushSubmit] = useState(false)
  console.log(pushSubmit)
  

  useEffect(() => {
    if (initialValues && initialValues.things_cat) {
      setThingsCat(initialValues.things_cat);
    }
  }, [initialValues]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading categories: {error.message}</p>;

  // 動的バリデーションスキーマの作成

  const createValidation = (fields) => {
    const shape = {};
    fields.forEach(field => {
      if (field.validation) {
        shape[field.name] = field.validation;
      }
    });
    return Yup.object().shape(shape);
  };
  
  const isFieldRequired = (field) => {
    if (!field.validation) return false;
  
    try {
      field.validation.validateSync(undefined);
    } catch (error) {
      return error.message.includes('必須項目です');
    }
  
    return false;
  };
  const handleImageChange = async (e, setFieldValue, fieldName, index) => {
    const file = e.target.files[0];
    if (file) {
      if (previews[fieldName] && previews[fieldName][index]) {
        URL.revokeObjectURL(previews[fieldName][index]);
      }

      const options = {
        maxSizeMB: 1,           // 最大サイズ1MB
        maxWidthOrHeight: 1024, // 最大の幅または高さ
        useWebWorker: true      // Web Workerを使用
      };

      try {
        const compressedFile = await imageCompression(file, options);
        const imageUrl = URL.createObjectURL(compressedFile);
        setFieldValue(`${fieldName}[${index}]`, compressedFile);

        setPreviews((prev) => ({
          ...prev,
          [fieldName]: {
            ...prev[fieldName],
            [index]: imageUrl
          }
        }));

        if (imageFields.length < maxImages && !imageFields.includes(index + 1)) {
          setImageFields([...imageFields, index + 1]);
        }
      } catch (error) {
        console.error('Error compressing image:', error);
      }
    }
  };

  const renderField = (field, values, setFieldValue) => {
    switch (field.type) {
      case 'text':
      case 'number':
        return (
          <div key={field.name} className='form__cont-input'>
            <label htmlFor={field.name}>
              {field.label}
              {isFieldRequired(field) && <span style={{ color: "rgba(245, 149, 32, 1)" }}>＊</span>}
            </label>
            <div className='form__cont-input-inner'>
              {field.b_uint && <span style={{ marginRight: '5px' }}>{field.b_uint}</span>}
              <Field 
                name={field.name}
                type={field.type} 
                placeholder={field.placeholder}
              />
              {field.a_uint && <span style={{ marginLeft: '5px' }}>{field.a_uint}</span>}
            </div>
            {field.description && <small>{field.description}</small>}
            <ErrorMessage name={field.name} component="p" className="orange" />
          </div>
        );

      case 'image':
        if (type === "editform") {
          return null;
        } else {
        return(
          <>
            {imageFields.map((fieldId, index) => (
              <div key={fieldId} className='form__cont-img'>
                {index === 0 && <label htmlFor={`${field.name}-${index}`}>{field.label}</label>}
                <div className='preview-wrap'>
                {previews[field.name] && previews[field.name][index] && (
                  <img src={previews[field.name][index]} alt={`Preview ${index}`} className="preview" />
                )}
                </div>
                <input
                  id={`image-${index}`}
                  name={`${field.name}[${index}]`}
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageChange(e, setFieldValue, field.name, index) }
                />
                {field.description && <small>{field.description}</small>}
              </div>
            ))}
          </>
        )
        }
      
      // case 'oneimage':
      //   return (
      //     <div>
      //       <label htmlFor={field.name}>{field.label}</label>
      //       <input
      //         type="file"
      //         accept="image/*"
      //         onChange={(e) => handleImageChangeSingle(e, setFieldValue)}
      //       />
      //       <ErrorMessage name={field.name} component="div" className="error" />
      //     </div>
      //   );

      case 'textbox':
        return (
          <div className='form__cont-input'>
            <label htmlFor={field.name}>{field.label}</label>
            <Field name={field.name} as="textarea" rows="4" />
            {field.description && <small>{field.description}</small>}
            <ErrorMessage name={field.name} component="p" className="orange" />
          </div>
        );

      case 'radio':
        return (
          <div key={field.name} className='form__cont-select'>
            <label>
              {field.label}
              {isFieldRequired(field) && <span style={{ color: "rgba(245, 149, 32, 1)" }}>＊</span>}
            </label>
            {(categories[field.category] || []).map(option => {
              if (
                (option.id === 'cost' && type !== "transaction") ||
                (option.id === 'rent' && type !== "sharehouse") ||
                (option.id === 'available' && type !== "sharehouse")
              ) {
                return null;
              }
              return (
                <div key={option.id}>
                  <Field
                    type="radio"
                    name={field.name}
                    value={option.id.toString()}
                    id={`${field.name}-${option.id}`}
                    checked={values[field.name] != null && values[field.name] === option?.id?.toString()}
                    onChange={(e) => {
                      setFieldValue(field.name, e.target.value);
                      if (field.name === 'things_cat'){
                        setThingsCat(option.id.toString());
                      }
                      console.log(thingsCat)
                    }}
                  />
                  <label htmlFor={`${field.name}-${option.id}`}>{option.name}</label>
              </div>
              )
            })}
            <ErrorMessage name={field.name} component="p" className="orange" />
          </div>
        );
      
      case 'checkbox':
        if (type === "editform") {
          return null;
        } else {
        return (
          <div key={field.name} className='form__cont-select'>
            <label>
              {field.label}
              {isFieldRequired(field) && <span style={{ color: "rgba(245, 149, 32, 1)" }}>＊</span>}
            </label>
            <FieldArray
              name={field.name}
              render={(arrayHelpers) => (
                <div>
                  {/* categories[field.category] が正しい配列を参照しているか確認 */}
                  {(categories[field.category] || []).map(option => (
                    <div key={option.id}>
                      <label>
                        <input
                          type="checkbox"
                          value={option.id.toString()}
                          checked={values[field.name]?.includes(option.id.toString())}
                          onChange={(e) => {
                            const value = option.id.toString();
                            if (e.target.checked) {
                              arrayHelpers.push(value);  // チェックボックスがオンなら追加
                            } else {
                              const index = values[field.name]?.indexOf(value);
                              arrayHelpers.remove(index);  // チェックボックスがオフなら削除
                            }
                            if (field.name === 'things_cat'){
                              setThingsCat(option.name);
                            }
                            console.log(thingsCat)
                            console.log( value )
                          }}
                        />
                        {option.name}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            />
            {field.description && <small>{field.description}</small>}
            <ErrorMessage name={field.name} component="p" className="orange" />
          </div>
        );
        }

      case 'boolean':
        return (
          <div key={field.name} className='form__cont-select'>
            {/* <label>{field.label}</label> */}
            <div>
              <label>
                <input
                  type="checkbox"
                  name={field.name}
                  checked={values[field.name] === true}
                  onChange={() => setFieldValue(field.name, !values[field.name])} 
                />
                有料枠に掲載する
              </label>
            </div>
            {field.description && <small>{field.description}</small>}
            <ErrorMessage name={field.name} component="p" className="orange" />
          </div>
        );

          
      case 'date':
        return (
          <div key={field.name} className='form__cont-input'>
            <label htmlFor={field.name}>
              {field.label}
              {isFieldRequired(field) && <span style={{ color: "rgba(245, 149, 32, 1)" }}>＊</span>}
            </label>
            <DatePicker
              id={field.name}
              selected={values[field.name]}
              onChange={(date) => setFieldValue(field.name, date)}
              dateFormat="yyyy/MM/dd"
              placeholderText={field.placeholder}
            />
            <ErrorMessage name={field.name} component="p" className="orange" />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className='form'>
    { type === "postform" ?(
      <>
      <h1 className='form__ttl'>{title || 'Shared House'}</h1>
      <h3 className='form__ttl'>新規投稿</h3>
      <div className='form__discription'>
        <span>必要項目を入力してください</span><br></br>
        <p className='orange'>＊</p><p className='green'>は必須項目です</p>
      </div>
      </>
    ):type === "editform" ?(
      <>
      <h1 className='form__ttl'>{title || 'Shared House'}</h1>
      <h3 className='form__ttl'>投稿編集</h3>
      <div className='form__discription'>
        <span>変更したい項目を編集してください</span><br></br>
        <p className='orange'>＊</p><p className='green'>は必須項目です</p>
      </div>
      </>
    ):null
    }
    <Formik
      // initialValues={formConfig.fields.reduce((acc, field) => {
      //   acc[field.name] = field.initialValue || (field.type === 'checkbox' ? [] : '');
      //   return acc;
      // }, {})}
      initialValues={initialValues}
      validationSchema={createValidation(formConfig.fields)}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        const formData = new FormData();
        Object.keys(values).forEach(key => {
          if (key === 'images' && Array.isArray(values[key])) {
            values[key].forEach((image, index) => {
              if (image) {
                formData.append(`images[${index}]`, image); // File オブジェクトを追加
              }
            });
          }else if (key === 'ident-images' && Array.isArray(values[key])){
            values[key].forEach((image, index) => {
              if (image) {
                formData.append(`ident-images[${index}]`, image); // File オブジェクトを追加
              }
            });
          } else if (Array.isArray(values[key])) {
            values[key].forEach(item => formData.append(`${key}[]`, item));
          } else {
            formData.append(key, values[key]);
          }
        });
        const token = localStorage.getItem('token');
        if (type === "login_form") {
          const { ID: custom_id, PASSWORD: password } = values;
          axios.post(apiUrl.submit,{
            custom_id: custom_id, 
            password: password,
          }, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(response => {
            const data = response.data
            const accessToken = response.data.token;
            const userid = response.data.userid;
            console.log('ユーザー:', data);
            localStorage.setItem('token', accessToken);
            localStorage.setItem('userid', userid);
            setCurrentPage('login_comp')
            setIsLogin(true)
          })
          .catch(error => {
            setIsWrong(true)
            console.error('エラー詳細:', error.response ? error.response.data : error);
          })
          .finally(() => {
            setSubmitting(false);
          });
        } else if (currentPage === 'terms' || currentPage === 'sorting') {
          const updatedValues = {};
          let searchParams = ""
          let URLParams = new URLSearchParams(window.location.search);
          for (let [key, value] of formData.entries()) {
            const cleanKey = key.replace(/\[\]$/, '');
            if (!updatedValues[cleanKey]) {
              updatedValues[cleanKey] = [];
            }
            updatedValues[cleanKey].push(value); // 配列として値を追加
          }
          if(currentPage === 'terms'){
          searchParams = Object.keys(updatedValues)
            .map((key) => {
              const values = updatedValues[key].filter(value => value !== '');  // 空値を除外
              return `${key}=${values.join(',')}`;
            })
            .join('&');
          }

          if (currentPage === 'sorting') {
            const sortingParam = `sorting=${updatedValues['sorting']}`;

            if (URLParams) {
              URLParams.delete('sorting');
              const urlParamsString = decodeURIComponent(URLParams.toString());
              console.log('urlParamsString', urlParamsString)
              searchParams = `${urlParamsString}&${sortingParam}`;
              console.log("New params:", searchParams)
            } else {
              searchParams = sortingParam;
            }
          }
          const newUrl = `${window.location.pathname}?${searchParams}`;
          navigate(newUrl);
          setSearchParams(searchParams)
          
          setSubmitting(false);
          closeModal();

        }else{
          const headers = {
            'Content-Type': 'multipart/form-data',
          };
          if (token) {
            headers['Authorization'] = `Token ${token}`;
          }
          axios.post(apiUrl.submit, formData, { headers })
          // console.log(apiUrl.submit)
          // console.log("POST Data:", formData)
          .then(response => {
            const token = response.data.token;
            const userid = response.data.userid;
            if (token) {
              localStorage.setItem('token', token);
              localStorage.setItem('userid', userid);
              setCurrentPage('creat_user_comp');
              setIsLogin(true);
            }else{
              if (type === "postform") {
                if (response.data.message === "本人確認") {
                  window.location.href = '/post_complete_error';
                // }else if(Array.isArray(response.data)){
                //   const [postType, postId] = response.data;
                //   window.location.href = '/payment';
                }else{
                  window.location.href = '/post_complete';
                }
              } else if (type === "identification"){
                openModal()
                setCurrentPage('identification_comp');
              } else if(type === "userimage_form" || type === "username_form" || type === "mailladdress_form" || type === "password_form" ){
                openModal()
                setCurrentPage('user_edition_comp');
              }else {
                openModal()
                setCurrentPage('edit_comp');
              }
            }
          })
          .catch(error => {
            console.error('エラー:', error);
          })
          .finally(() => {
            setSubmitting(false);
          });
        }
      }}
    >
      {({ values, setFieldValue, isSubmitting, isValid, errors }) => (
        
        <Form encType="multipart/form-data" className='form__cont'>
          {formConfig.fields.map(field => {
            if (field.name === 'maker' || field.name === 'eileage') {
              if (thingsCat !== '2') {
                return null;
              }
            }
            return renderField(field, values, setFieldValue);
          })}
          { pushSubmit === true && Object.keys(errors).length > 0 && (
            <div className="error-messages" style={{ margin:'30px 0 -10px', textAlign:'center'}}>
              <p className='orange'>送信できません</p>
              <p className='orange'>入力項目を確認してください</p>
            </div>
          )}
          { type === "login_form" ?(
            <button type="submit" className='submit-btn btn-green' onClick={() => setPushSubmit(true)}>{isSubmitting ? "ログイン中..." : "ログイン"}</button>
            ): currentPage === "terms" || currentPage === "sorting" ?(
            <button className='submit-btn btn-green' onClick={ () => {hundleSearch(); setPushSubmit(true);}}>{isSubmitting ? "検索中..." : "検索"}</button>
            ): type === "create_user" ?(
              <button type="submit" className='submit-btn btn-green'onClick={() => setPushSubmit(true)}>{isSubmitting ? "登録中..." : "登録"}</button>
            ):(
              <button type="submit" className='submit-btn btn-green'onClick={() => setPushSubmit(true)}>{isSubmitting ? "送信中..." : "送信"}</button>
            )
          }
        </Form>
      )}
    </Formik>
    </div>
  );
};

export default PostForm;

